import { UNIT_TYPES } from 'constants/unitTypes';
import { getManageProductApplicationSummary } from 'scripts/selectors';
import { getOriginalScenarioUuid } from './selectors';

import { getSeedRateForAreaChartData } from 'util/formatters/data-viz/seed';
import { convert, inferUnit } from 'util/unitConversion';
import { formatNumberRoundToNearest } from 'util/formatters/numberFormatter';

const scenarioParser = ({ state, script, plantingPlanParams, productValidationValues }) => {
  const seedSummary = getManageProductApplicationSummary(state, script)[0]; // taking first because when grouping by product, there should only be one currently
  const { numSeedBags, area } = seedSummary;
  const costSeedPerAcre = { q: (numSeedBags.q * plantingPlanParams['price-product'] / area.q), u: UNIT_TYPES.usd_acre};
  const scenarioUuid = script.id;
  const seedChartData = getSeedRateForAreaChartData(script, productValidationValues);

  // The original scenario is the FVSS recommendation, which does not have a 
  // currentAveragePopulation input by the user, so we get the real average rate
  // to then used it in the inputs, if the feature is enabled.
  if (scenarioUuid === getOriginalScenarioUuid(state)) {
    const plantingRateUserUnit = convert({
      from: seedSummary.avgRate,
      to: { u: inferUnit('seed-density').unitKey }
    });
    plantingPlanParams.currentAveragePopulation = formatNumberRoundToNearest(plantingRateUserUnit.q, 1);
  }

  return Object.assign({}, seedSummary,
    {
      costSeedPerAcre,
      meta: script.meta,
      plantingPlanParams,
      scenarioUuid,
      seedChartData,
      zones: script.zones,
      tag: script.tag,
      densityCurveField: script.densityCurveField
    });
};

export default scenarioParser;
